/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { EsignFinalPackageStatus } from './EsignFinalPackageStatus';
import {
    EsignFinalPackageStatusFromJSON,
    EsignFinalPackageStatusFromJSONTyped,
    EsignFinalPackageStatusToJSON,
    EsignFinalPackageStatusToJSONTyped,
} from './EsignFinalPackageStatus';
import type { EsignSignerStatus } from './EsignSignerStatus';
import {
    EsignSignerStatusFromJSON,
    EsignSignerStatusFromJSONTyped,
    EsignSignerStatusToJSON,
    EsignSignerStatusToJSONTyped,
} from './EsignSignerStatus';

/**
 * 
 * @export
 * @interface PublicSignerSubmitSuccessResponse
 */
export interface PublicSignerSubmitSuccessResponse {
    /**
     * 
     */
    request_id: string;
    /**
     * 
     */
    request_title: string | null;
    /**
     * 
     */
    signer_id: string;
    /**
     * 
     */
    signer_status: EsignSignerStatus;
    /**
     * 
     */
    signer_completed_at: Date;
    /**
     * 
     */
    request_status: PublicSignerSubmitSuccessResponseRequestStatusEnum;
    /**
     * 
     */
    request_completed_at: Date | null;
    /**
     * 
     */
    final_package_status: EsignFinalPackageStatus | null;
    /**
     * 
     */
    completion_state: PublicSignerSubmitSuccessResponseCompletionStateEnum;
}


/**
 * @export
 */
export const PublicSignerSubmitSuccessResponseRequestStatusEnum = {
    Pending: 'Pending',
    Completed: 'Completed',
} as const;
export type PublicSignerSubmitSuccessResponseRequestStatusEnum = typeof PublicSignerSubmitSuccessResponseRequestStatusEnum[keyof typeof PublicSignerSubmitSuccessResponseRequestStatusEnum];

/**
 * @export
 */
export const PublicSignerSubmitSuccessResponseCompletionStateEnum = {
    SignerCompleted: 'signer_completed',
    RequestCompleted: 'request_completed',
} as const;
export type PublicSignerSubmitSuccessResponseCompletionStateEnum = typeof PublicSignerSubmitSuccessResponseCompletionStateEnum[keyof typeof PublicSignerSubmitSuccessResponseCompletionStateEnum];


/**
 * Check if a given object implements the PublicSignerSubmitSuccessResponse interface.
 */
export function instanceOfPublicSignerSubmitSuccessResponse(value: object): value is PublicSignerSubmitSuccessResponse {
    if (!('request_id' in value) || value['request_id'] === undefined) return false;
    if (!('request_title' in value) || value['request_title'] === undefined) return false;
    if (!('signer_id' in value) || value['signer_id'] === undefined) return false;
    if (!('signer_status' in value) || value['signer_status'] === undefined) return false;
    if (!('signer_completed_at' in value) || value['signer_completed_at'] === undefined) return false;
    if (!('request_status' in value) || value['request_status'] === undefined) return false;
    if (!('request_completed_at' in value) || value['request_completed_at'] === undefined) return false;
    if (!('final_package_status' in value) || value['final_package_status'] === undefined) return false;
    if (!('completion_state' in value) || value['completion_state'] === undefined) return false;
    return true;
}

export function PublicSignerSubmitSuccessResponseFromJSON(json: any): PublicSignerSubmitSuccessResponse {
    return PublicSignerSubmitSuccessResponseFromJSONTyped(json, false);
}

export function PublicSignerSubmitSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicSignerSubmitSuccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'request_id': json['request_id'],
        'request_title': json['request_title'],
        'signer_id': json['signer_id'],
        'signer_status': EsignSignerStatusFromJSON(json['signer_status']),
        'signer_completed_at': (json['signer_completed_at'] == null ? json['signer_completed_at'] : parseDateTime(json['signer_completed_at'])),
        'request_status': json['request_status'],
        'request_completed_at': (json['request_completed_at'] == null ? null : parseDateTime(json['request_completed_at'])),
        'final_package_status': EsignFinalPackageStatusFromJSON(json['final_package_status']),
        'completion_state': json['completion_state'],
    };
}

export function PublicSignerSubmitSuccessResponseToJSON(json: any): PublicSignerSubmitSuccessResponse {
    return PublicSignerSubmitSuccessResponseToJSONTyped(json, false);
}

export function PublicSignerSubmitSuccessResponseToJSONTyped(value?: PublicSignerSubmitSuccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'request_id': value['request_id'],
        'request_title': value['request_title'],
        'signer_id': value['signer_id'],
        'signer_status': EsignSignerStatusToJSON(value['signer_status']),
        'signer_completed_at': value['signer_completed_at'] == null ? value['signer_completed_at'] : serializeDateTime(value['signer_completed_at']),
        'request_status': value['request_status'],
        'request_completed_at': value['request_completed_at'] == null ? value['request_completed_at'] : serializeDateTime(value['request_completed_at']),
        'final_package_status': EsignFinalPackageStatusToJSON(value['final_package_status']),
        'completion_state': value['completion_state'],
    };
}

